import Glide from '@glidejs/glide';

// This file contains global configuration that should be called on every page load.
document.addEventListener('alpine:init', () => {
    // Footer
    Alpine.data('footerData', () => ({
        expanded: false,
        init() {
            this.$watch('expanded', (value) => {
                if (value) {
                    setTimeout(() => this.scrollToBottom(), 500)
                }
            });
        },
        scrollToBottom() {
            window.scrollTo({left: 0, top: document.body.scrollHeight, behavior: "smooth"});
        }
    }));

    // Header
    Alpine.data('navData', () => ({
        showMenu: false,
        active: null,
        main: null,
        init() {
            this.main = document.querySelector("main");
        },
        openMenu() {
            this.showMenu = true;
            this.main.classList.add("hidden");
        },
        closeMenu() {
            this.showMenu = false;
            this.main.classList.remove("hidden");
        }
    }))
});

if (document.querySelectorAll('.glide') !== null) {

    var sliders = document.querySelectorAll('.glide');

    for (var i = 0; i < sliders.length; i++) {
        var glide = new Glide(sliders[i], {
            type: 'carousel',
            perView: 3,
            breakpoints: {
                500: {
                    perView: 1
                },
                900: {
                    perView: 2
                }
            },
            focusAt: 'center',
            autoplay: 2000
        });

        glide.mount();
    }
}

if (document.querySelectorAll('.glideGroupSlider') !== null) {

    var sliders = document.querySelectorAll('.glideGroupSlider');

    for (var i = 0; i < sliders.length; i++) {
        var glide = new Glide(sliders[i], {
            type: 'slider',
            perView: 1,
            startAt: 0,
            focusAt: 'center',
            rewind: false
        });

        glide.mount();
    }
}
